import script from "./HomepageGroupsFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepageGroupsFilter.vue?vue&type=script&setup=true&lang=js"

import "./HomepageGroupsFilter.vue?vue&type=style&index=0&id=60b38360&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60b38360"]])

export default __exports__